<template>
	<div>
		<Layout :navFixed="true" :transparent="true">
			<div class="container mt-3">
				<div class="row row-xs d-flex">
					<div class="col-12 mt-4 mb-4">
						<h1>Mi cuenta x</h1>
					</div>
				</div>
				<div class="row row-xs d-flex no-wrap">
					<AccountSidebar />

					<div class="page  ">
						<div class="card" v-if="tab == 'tickets'">
							<div class="card-body">
								<h2>Mis tickets</h2>
								<TicketList :hideUserColumn="true" />
							</div>
						</div>
						<div class="card" v-if="tab == 'memberships'">
							<div class="card-body">
								<h2>Mis membresías</h2>
								<MembershipList />
							</div>
						</div>
						<div class="card" v-if="tab == 'events'">
							<div class="card-body">
								<h2>Mis eventos</h2>
								<PromoteEvents />
							</div>
						</div>
						<div class="card" v-if="tab == 'personal-data'">
							<div class="card-body">
								<h2>Datos personales</h2>
								<div class="p-4 mt-3">
									<ProfileForm />
								</div>
							</div>
						</div>
						<div class="card" v-if="tab == 'security'">
							<div class="card-body">
								<h2>Inicio de sesión y seguridad</h2>
								<div class="p-4 mt-3">
									<Security />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	</div>
</template>

<script>
import Layout from "@/components/Layout"
import AccountSidebar from "./AccountSidebar"
import ProfileForm from "./ProfileForm"
import Security from "./Security"
import TicketList from "./TicketList"
import MembershipList from "./MembershipList"
import PromoteEvents from "./PromoteEvents"

export default {
	name: "Account",
	components: {
		Layout,
		AccountSidebar,
		ProfileForm,
		Security,
		TicketList,
		MembershipList,
		PromoteEvents
	},
	data() {
		return {
			loading: false,
			tab: null
		}
	},

	async beforeMount() {
		if (!this.$route.params.tab) this.tab = "tickets"
		else this.tab = this.$route.params.tab
	},

	methods: {}
}
</script>

<style scoped lang="scss">
.page {
	flex-grow: 1;
	flex-shrink: 1;
}
.no-wrap {
	flex-wrap: nowrap;
}
</style>
